/* eslint-disable */
import { PluginContainerData } from './common.js';

import { MapType } from './plugin_map.enums.js';

export function mapTypeFromJSON(object: any): MapType {
  switch (object) {
    case 0:
    case "ROADMAP":
      return MapType.ROADMAP;
    case 1:
    case "SATELITE":
      return MapType.SATELITE;
    case 2:
    case "HYBRID":
      return MapType.HYBRID;
    case 3:
    case "TERRAIN":
      return MapType.TERRAIN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MapType.UNRECOGNIZED;
  }
}

export function mapTypeToJSON(object: MapType): string {
  switch (object) {
    case MapType.ROADMAP:
      return "ROADMAP";
    case MapType.SATELITE:
      return "SATELITE";
    case MapType.HYBRID:
      return "HYBRID";
    case MapType.TERRAIN:
      return "TERRAIN";
    default:
      return "UNKNOWN";
  }
}

export interface MapData {
  /** Styling for the map's container. */
  containerData?: PluginContainerData;
  /** Map settings. */
  mapSettings?: MapSettings;
}

export interface MapSettings {
  /** flynt-disable unannotated-pii-fields */
  address?: string;
  /** Sets whether the map is draggable. */
  draggable?: boolean;
  /** Sets whether the location marker is visible. */
  marker?: boolean;
  /** Sets whether street view control is enabled. */
  streetViewControl?: boolean;
  /** Sets whether zoom control is enabled. */
  zoomControl?: boolean;
  /** Location latitude. */
  lat?: number;
  /** Location longitude. */
  lng?: number;
  /** Location name. */
  locationName?: string;
  /** Sets whether view mode control is enabled. */
  viewModeControl?: boolean;
  /** Initial zoom value. */
  initialZoom?: number;
  /** Map type. `HYBRID` is a combination of the `ROADMAP` and `SATELLITE` map types. */
  mapType: MapType;
}

const baseMapData: object = {};

export const MapData = {
  fromJSON(object: any): MapData {
    const message = { ...baseMapData } as MapData;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.mapSettings =
      object.mapSettings !== undefined && object.mapSettings !== null
        ? MapSettings.fromJSON(object.mapSettings)
        : undefined;
    return message;
  },

  toJSON(message: MapData): unknown {
    const obj: any = {};
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.mapSettings !== undefined &&
      (obj.mapSettings = message.mapSettings
        ? MapSettings.toJSON(message.mapSettings)
        : undefined);
    return obj;
  },
};

const baseMapSettings: object = { mapType: MapType.ROADMAP };

export const MapSettings = {
  fromJSON(object: any): MapSettings {
    const message = { ...baseMapSettings } as MapSettings;
    message.address =
      object.address !== undefined && object.address !== null
        ? String(object.address)
        : undefined;
    message.draggable =
      object.draggable !== undefined && object.draggable !== null
        ? Boolean(object.draggable)
        : undefined;
    message.marker =
      object.marker !== undefined && object.marker !== null
        ? Boolean(object.marker)
        : undefined;
    message.streetViewControl =
      object.streetViewControl !== undefined &&
      object.streetViewControl !== null
        ? Boolean(object.streetViewControl)
        : undefined;
    message.zoomControl =
      object.zoomControl !== undefined && object.zoomControl !== null
        ? Boolean(object.zoomControl)
        : undefined;
    message.lat =
      object.lat !== undefined && object.lat !== null
        ? Number(object.lat)
        : undefined;
    message.lng =
      object.lng !== undefined && object.lng !== null
        ? Number(object.lng)
        : undefined;
    message.locationName =
      object.locationName !== undefined && object.locationName !== null
        ? String(object.locationName)
        : undefined;
    message.viewModeControl =
      object.viewModeControl !== undefined && object.viewModeControl !== null
        ? Boolean(object.viewModeControl)
        : undefined;
    message.initialZoom =
      object.initialZoom !== undefined && object.initialZoom !== null
        ? Number(object.initialZoom)
        : undefined;
    message.mapType =
      object.mapType !== undefined && object.mapType !== null
        ? mapTypeFromJSON(object.mapType)
        : MapType.ROADMAP;
    return message;
  },

  toJSON(message: MapSettings): unknown {
    const obj: any = {};
    message.address !== undefined && (obj.address = message.address);
    message.draggable !== undefined && (obj.draggable = message.draggable);
    message.marker !== undefined && (obj.marker = message.marker);
    message.streetViewControl !== undefined &&
      (obj.streetViewControl = message.streetViewControl);
    message.zoomControl !== undefined &&
      (obj.zoomControl = message.zoomControl);
    message.lat !== undefined && (obj.lat = message.lat);
    message.lng !== undefined && (obj.lng = message.lng);
    message.locationName !== undefined &&
      (obj.locationName = message.locationName);
    message.viewModeControl !== undefined &&
      (obj.viewModeControl = message.viewModeControl);
    message.initialZoom !== undefined &&
      (obj.initialZoom = message.initialZoom);
    message.mapType !== undefined &&
      (obj.mapType = mapTypeToJSON(message.mapType));
    return obj;
  },
};
